import DateFnsUtils from '@date-io/date-fns';
import { Icon, InputAdornment, Tooltip } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { ptBR } from 'date-fns/locale';
import React from 'react';


export function TableCommonDateFilter(props: any) {

    const [date, setDate] = React.useState<MaterialUiPickersDate>(null);

    return (
        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
            <DatePicker
                autoOk
                clearable
                disableFuture
                allowKeyboardControl
                format="dd/MM/yyyy"
                value={date}
                onChange={(date) => {
                    setDate(date);
                    props.onFilterChanged(props.columnDef.tableData.id, date);
                }}
                invalidDateMessage="Formato de data inválido"
                minDateMessage="A data não deve exceder a data mínima"
                maxDateMessage="A data não deve exceder a data máxima"
                cancelLabel="Cancelar"
                clearLabel="Limpar"
                okLabel="Ok"
                InputProps={{
                    startAdornment: (
                        <Tooltip title="Filtrar">
                            <InputAdornment position="start">
                                <Icon>filter_list</Icon>
                            </InputAdornment>
                        </Tooltip>
                    ),
                }} />
        </MuiPickersUtilsProvider>
    );
}